import React from "react";
import FlexText from "../../flexText";
//import ThreeCol from "../containers/threecol";

export const replaceP = (string) => {
  if (typeof string === 'undefined') {
    return string;
  }
  return string.replace(/<\/?[^>]+(>|$)/g, "")
}

const Fact = ({ item }) => (
  <div className="slide">
    <div
      className="factoid"
      style={{
        fontWeight: "500",
        lineHeight: "1.5em",
        letterSpacing: ".02em",
        textAlign: "center"
      }}
    >
      <FlexText
        max="72"
        min="46"
        pert=".285"
        classes="numHilt factoidRow"
        blockStyles={{ marginBottom: "12px" }}
        styles={{
          fontFamily: "Oswald",
          color: "#1375af",
          lineHeight: "80px",
          letterSpacing: "0em",
          fontWeight: "500",
          marginBottom: ".6em",
          textTransform: "none"
        }}
      >
        {replaceP(item.field_text_1)}
      </FlexText>
      <FlexText
        max="18"
        min="15"
        pert=".063"
        classes="textHilt"
        styles={{
          fontFamily: "Oswald",
          lineHeight: "26px",
          color: "#444",
          display: "block",
          fontWeight: "500",
          letterSpacing: ".02em",

          whiteSpace: "normal"
        }}
      >
        {replaceP(item.field_longtext_1)}
      </FlexText>
      <FlexText
        max="16"
        min="14"
        pert="0.04"
        margins="12px"
        styles={{
          lineHeight: "24px",
          display: "inline-block",
          fontFamily: "Roboto",
          textAlign: "center",
          fontWeight: "500",
          textTransform: "none",
          color: "#444",
          marginTop: "12px"
        }}
      >
        {replaceP(item.field_longtext_2)}
      </FlexText>
    </div>
  </div>
);

export default Fact;
